import { createApp } from 'vue'
import App from './App.vue'
import 'remixicon/fonts/remixicon.css'
import 'animate.css'

createApp(App).mount('#app')
